define(
    "diy/undo-redo/Observable",
    /**
     *
     * @returns {module.undoRedo.Observable}
     */
    function () {
        'use strict';
         var ALL_TOPICS = '*';
        /**
         * @class module.undoRedo.Api
         * @template module.undoRedo.Api
         * @lends {module.undoRedo.Api.prototype}
         * @constructor
         */
        var Observable = Klazz.extend({
            observers: undefined,

            /**
             *
             * @param {Function} callback
             * @param {String=} topic
             */
            attachObserver: function attachObserver(callback, topic) {
                if (typeof this.observers === "undefined") {
                    this.observers = [];
                }

                this.observers.push(
                    {
                        callback: callback,
                        topic: (typeof topic !== 'undefined') ? topic : null
                    }
                );
            },
            /**
             *
             * @param {Function} observer
             */
            detachObserver: function detachObserver(observer) {
                this.observers.forEach(function (value, index, array) {
                    if (value === observer) {
                        array.splice(index, 1);
                    }
                });
            },

            /**
             * notify registered observers [only on triggered topic]
             *
             * @param {String=} topic
             * @param {*=} data
             * @param {*=} subject

             */
            notifyObservers: function notifyObservers(topic, data, subject) {

                if (typeof subject === 'undefined') {
                    subject = this;
                }

                this.observers.forEach(
                    /**
                     * @param {{topic: String, callback: Function}} observer
                     */
                    function (observer) {
                        if (observer.topic === ALL_TOPICS) {
                            observer.callback.call(this, subject, data, topic);
                        } else if (typeof topic !== 'undefined') {
                            if (observer.topic !== null &&
                                observer.topic.toString() === topic.toString()
                            ) {
                                observer.callback.call(this, subject, data);
                            }
                        } else {
                            if (observer.topic === null) {
                                observer.callback.call(this, subject, data);
                            }
                        }
                    }.bind(this)
                );
            }

        });

        return Observable;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/Observable.js
 ** module id = 907
 ** module chunks = 0
 **/